var React = require('react');

function Desktop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.454 20.22H14.11a1.346 1.346 0 0 1-1.343-1.347V16.85H8.735v2.023c0 .744-.602 1.348-1.344 1.348H6.047a.673.673 0 0 0-.672.674c0 .372.3.674.672.674h9.407a.672.672 0 0 0 .672-.674c0-.372-.3-.674-.672-.674zM20.326 0H1.176C.526 0 0 .566 0 1.264v12.975c0 .697.527 1.263 1.176 1.263h19.15c.649 0 1.176-.566 1.176-1.263V1.264C21.502.566 20.975 0 20.326 0zm-.168 14.154H1.344V1.348h18.814v12.806z","fill":"currentColor","fillRule":"nonzero"}));
}

Desktop.defaultProps = {"width":"22","height":"22"};

module.exports = Desktop;

Desktop.default = Desktop;
